export default function TradeIcon({
  width = 24,
  height = 24,
  color = '#363744',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <path
        d="M1992,1385.667l16-16h-8V1367h13.333v13.333h-2.667v-8l-16,16Z"
        transform="translate(-1981.333 -1356.333)"
        fill="#fff"
      ></path>
    </svg>
  );
}
